import React, { useMemo, memo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { useGroupedHover } from '@aytm/app/insights/dashboard/components/hooks'
import { useBlinkSubscription } from '@aytm/app/insights/dashboard/components/hooks/useBlink'

import Point from '../Point'

import './Indicator.scss'

const CLASS = 'insights-portal-indicator'

const arePropsEqual = (pre, cur) =>
  pre.index === cur.index && pre.onGetColumnData === cur.onGetColumnData && pre.showSigtest === cur.showSigtest

const Indicator = memo(props => {
  // const index = props.index ?? -1
  const item = props.item || null
  const getColumnData = props.onGetColumnData || null
  const showSigtest = props.showSigtest ?? true

  const targetRef = useBlinkSubscription(item?.uid)

  const { letter, description, isExternalData } = useMemo(() => getColumnData(item), [getColumnData, item])

  const className = props.className || CLASS

  const [ref] = useGroupedHover(props.index, 'indicator')

  const assignRef = useCallback(
    node => {
      ref(node)
      targetRef.current = node
    },
    [ref, targetRef]
  )

  const warning =
    props.filtered && isExternalData ? (
      <Point
        className={`${CLASS}-warning`}
        tipName={'warnExternalData'}
        showOn={'mouseenter'}
        hideOn={'click&propagate click:body wheel:body scroll:body mouseleave'}
      >
        <i className={'icon-aytmfd-attention'} />
      </Point>
    ) : null

  if (props.children) {
    return (
      <div ref={assignRef} className={`${className} ${className}--with-layers`}>
        <div className={`${CLASS}-layer`}>{props.children}</div>
        <div className={`${CLASS}-layer`}>
          <div className={`${CLASS}-left`}>
            <div className={`${CLASS}-description`}>{description}</div>
            {warning}
          </div>
          <div className={`${CLASS}-letter`}>{showSigtest ? letter : null}</div>
        </div>
      </div>
    )
  }
  return (
    <div ref={assignRef} className={className}>
      <div className={`${CLASS}-left`}>
        <div className={`${CLASS}-description`}>{description}</div>
        {warning}
      </div>
      <div className={`${CLASS}-letter`}>{showSigtest ? letter : null}</div>
    </div>
  )
}, arePropsEqual)

Indicator.displayName = 'Indicator'

Indicator.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  item: PropTypes.object,
  filtered: PropTypes.any,
  onGetColumnData: PropTypes.func.isRequired,
  showSigtest: PropTypes.bool,
  children: PropTypes.node
}

export default Indicator
